export default __webpack_public_path__ + "static/media/loading-bubbles.94d9ef86.svg";